<div class="modal-template default-modal">
  <form [formGroup]="libraryForm">
    <div class="modal-container">
      <div class="modal-header">
        <div class="title-text"> {{!data.value?.id ? ('button.create' | translate) : ('button.edit' | translate)}} {{ 'TimeEntryType' | translate }}</div>
        <div class="close-modal" (click)="closeModal()">
          <span class="j-icon-cross"></span>
        </div>
      </div>
      <div class="modal-body">
        <div class="content-container">


          <div class="input-container" [ngClass]="{ 'invalid-validation': f.get(['name']).errors && submittedForm }">
            <label>{{ 'table.name' | translate }}</label>
            <input type="text" placeholder="{{ 'common.typeHere' | translate }}" formControlName="name" />
          </div>

          <div class="input-container">
            <label>{{ 'billing.method' | translate }}</label>
            <ejs-dropdownlist
              formControlName="customRateType"
              [dataSource]="listBillingMethod"
              [fields]="{ text: 'name', value: 'value' }"
              [placeholder]="'common.select' | translate"
              (select)="onChangeBillingMethod($event.itemData.value)"
            >
            </ejs-dropdownlist>
          </div>

          <div class="custom-rates-container">
            <app-rates
            [currentRates]="currentRates"
            (changedRates)="changedRates($event)"
            [visibleButton]="isManyCurrency && f.get(['customRateType'])?.value !== 'default'"
            [label]="f.get(['customRateType'])?.value === 'custom' ? 'matter.card.matterEstimatesRate' : 'activities.list.rate'"
          ></app-rates>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="button-container">
          <button class="btn-template btn-blue dropdown-button"  (click)="onLibraryCreate()">
            {{ 'button.save' | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
